import { useEffect } from 'react'
import { useAuth } from '../AuthProvider'
import { Spinner, SpinnerSize, Stack } from '@fluentui/react'

const CallbackComponent = () => {
  const { userManager } = useAuth()

  useEffect(() => {
    userManager
      .signinRedirectCallback()
      .then(() => {
        window.location.href = '/'
      })
      .catch((error) => {
        console.error('Error completing signin:', error)
      })
  }, [userManager])

  return (
    <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { height: '100vh' } }}>
      <Spinner size={SpinnerSize.large} label="Processing login..." />
    </Stack>
  )
}

export default CallbackComponent
